import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/ConsumptionMeteringPointGroupModal.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import Button from '../../Common/Button';
import Loading from '../../Common/Loading';
import ConsumptionMeteringPointGroupAccordion from './ConsumptionMeteringPointGroupAccordion';

import { closeMenuIconBlack } from '../../../icons';

import { putMeteringPointGroup } from '../../../actions';
import { MeteringPointGroup, MeteringPointGroupPut } from '../../../types/consumptionRates';

export type ConsumptionMeteringPointGroupEditProps = {
  group: MeteringPointGroup;
  setShowEditModal: (value: React.SetStateAction<MeteringPointGroup | undefined>) => void;
  setRefreshData?: (value: React.SetStateAction<string>) => void;
};

const ConsumptionMeteringPointGroupEdit: React.FunctionComponent<ConsumptionMeteringPointGroupEditProps> = (
  props: ConsumptionMeteringPointGroupEditProps,
) => {
  const { t } = useTranslation();
  const { users } = OmaLummeApp.useState();

  const { group, setShowEditModal, setRefreshData } = props;

  const defaultMeteringPoints: MeteringPointGroupPut[] = [];
  group.meteringPoints.forEach((item) =>
    defaultMeteringPoints.push({
      meteringPointIdentifier: item.meteringPointIdentifier,
      customerIdentifier: item.customerIdentifier,
    }),
  );

  const [groupName, setGroupName] = React.useState<string>(group.groupName);
  const [meteringPoints, setMeteringPoints] = React.useState<MeteringPointGroupPut[]>(defaultMeteringPoints);
  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const resetForm = () => {
    setGroupName(group.groupName);
    setMeteringPoints(defaultMeteringPoints);
  };

  const submitForm = async (): Promise<void> => {
    setSubmitting(true);
    const groupSubmitStatus = await putMeteringPointGroup(users.activeUser.userId, groupName, JSON.stringify(meteringPoints), group.identifier);
    setSubmitting(false);
    if (groupSubmitStatus === 200) {
      setShowEditModal(undefined);
      setRefreshData && setRefreshData('groups');
    }
  };

  return (
    <>
      <div className={`modal ${styles.modalWrapper}`}>
        <div className={styles.modal}>
          <button className={styles.close} onClick={(): void => setShowEditModal(undefined)}>
            <img src={closeMenuIconBlack} alt={t('common:general.close')} />
          </button>
          <h1 className={styles.title}>{t(`consumption:meteringPointGroup.editGroupTitle`)}</h1>
          <p className={styles.ingress}>{t(`consumption:meteringPointGroup.editGroupIngress`)}</p>

          <header className={styles.header}>
            <div>
              <label htmlFor="groupName">
                {t(`consumption:meteringPointGroup.groupNameInputTitle`)} {t('customerService:contactUs.requiredField')}
              </label>
              <input
                type="text"
                id="groupName"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                placeholder={t(`consumption:meteringPointGroup.groupNameInputPlaceholder`)}
              />
            </div>
            <div>
              {submitting && <Loading size="small" />}
              {!submitting && <Button onClick={() => submitForm()}>{t(`common:general.save`)}</Button>}
              <Button className="buttonWhite" onClick={() => resetForm()}>
                {t(`common:general.cancel`)}
              </Button>
            </div>
          </header>

          <ConsumptionMeteringPointGroupAccordion
            type="create"
            user={users.parentUser}
            group={group}
            meteringPoints={{ meteringPoints, setMeteringPoints }}
          />
          {users.childUsers?.map((childUser) => (
            <ConsumptionMeteringPointGroupAccordion
              key={childUser.userId}
              type="create"
              user={childUser}
              group={group}
              meteringPoints={{ meteringPoints, setMeteringPoints }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ConsumptionMeteringPointGroupEdit;
